import { useTranslation } from "react-i18next";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Button from "../Button";

export type OnboardingPrimaryAction = "start" | "continue" | "finish";

type Props = {
	showPrevious: boolean;
	primaryAction: OnboardingPrimaryAction;
	canGoNext?: boolean;
	loading?: boolean;
	onPrevious: () => void;
	onNext: () => void;
};

const PRIMARY_ACTION_KEY = {
	start: "onboarding.actions.start",
	continue: "onboarding.actions.continue",
	finish: "onboarding.actions.finish",
} as const;

export const OnboardingFooter = ({
	showPrevious,
	primaryAction,
	canGoNext = true,
	loading = false,
	onPrevious,
	onNext,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const { t } = useTranslation();
	const insets = useSafeAreaInsets();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="flex-end"
			gap={16}
			padding={isMobile ? 16 : 24}
			paddingBottom={(isMobile ? 16 : 24) + insets.bottom}
			backgroundColor={theme.colors.surface}
			borderTopWidth={1}
			borderColor={theme.colors.surfaceVariant}
		>
			{showPrevious ? (
				<Button
					mode="outlined"
					icon="chevron-left"
					onPress={onPrevious}
					disabled={loading}
				>
					{t("onboarding.actions.previous")}
				</Button>
			) : null}
			<Button
				mode="contained"
				icon="chevron-right"
				onPress={onNext}
				disabled={!canGoNext || loading}
				loading={loading}
			>
				{t(PRIMARY_ACTION_KEY[primaryAction])}
			</Button>
		</Box>
	);
};
